export default {"src":"/_next/static/media/success.69779d5a.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};